import React, { useContext, useState, useEffect } from "react";
import styled from "styled-components";

import {useTranslation} from "react-i18next";
import { GlobalDataContext } from "../../../contexts/GlobalDataContext";
import { YearReportData } from "../../../interfaces/RankingsAndLevelsInterfaces";
import Colors from "../../../assets/colors/Colors";

const Wrapper = styled.div`
  min-height: 100%;
  padding-left: 10%;
  padding-right: 10%;
  padding-top: 0.8rem;
  color: #737373;

  .header__title {
    padding-top: 2.8rem;
    font-family: Mapfre-Bold;
    font-size: 3.41625rem;
    line-height: 1em;
    color: #737373;
  }

  .header__description {
    font-family: Mapfre-Medium;
  }

  .reports__last a {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: Mapfre-Black;
    border: 2px solid #737373;
    padding: 0.7rem 1.5rem;
    margin: 0;
    text-decoration: none;
    background: #ffffff;
    color: #737373;
    font-size: 1rem;
    cursor: pointer;
    text-align: center;
    transition: background 250ms ease-in-out,
                transform 150ms ease;
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 80%;
    box-shadow: 2px 2px 5px #00000033;
  }

  .reports__last a span {
    flex: 0 0 auto;
  }

  .reports__caret {
    display: inline-block;
    border-top: 0.4em solid transparent;
    border-bottom: 0.4em solid transparent;
    border-left: 0.8em solid ${Colors.headerNavigationRed};
    height: 0px;
  }

  .reports__caret::after {
    content: ' ';
  }

  .previous-reports {
    margin-top: 5rem;
  }

  .previous-reports__description {
    font-family: Mapfre-Light;
  }

  .previous-reports__separator {
    width: 10%;
    min-width: 30px;
    max-width: 150px;
    border-bottom: 2px solid #737373;
    margin: 10px 0;
  }

  .previous-reports__list {
    margin-top: 2rem;
  }

  .previous-reports__list ul {
    padding-left: 0px;
  }

  .previous-reports__list li {
    list-style: none;
  }

  .previous-reports__list li::before {
    list-style: none;
    border-top: 0.4em solid transparent;
    border-bottom: 0.4em solid transparent;
    border-left: 0.8em solid #737373;
    height: 0px;
    content: ' ';
    display: inline-block;
  }

  .previous-reports__list a {
    color: #737373;
    margin-left: 10%;
    font-family: Mapfre-Regular;
    font-size: 0.9rem;
    letter-spacing: 1px;
  }
`;

interface PreviousReportParams {
  report: YearReportData
}

const PreviousReport = ({ report }: PreviousReportParams) => {
  const { t, i18n } = useTranslation();
  const lng = i18n.language || window.localStorage.i18nextLng || 'es';

  if (!report['download_urls']) {
    return null;
  }

  // @ts-ignore
  const reportUrl = report['download_urls'][lng] || '#';

  return (
    <li>
      <a href={ reportUrl } target='_blank'>
        { t('pdfDownload.reports.report', { year: report.year + 1 }) }
      </a>
    </li>
  )
};

const PdfDownload = () => {
  const { t, i18n } = useTranslation();
  const lng = i18n.language || window.localStorage.i18nextLng || 'es';

  // @ts-ignore
  const { reportsAvailables, lastYearAvailable } = useContext(GlobalDataContext);

  const years = Object.keys(reportsAvailables).sort().reverse().slice(1, 6);
  const pastReports = years.map((year: string) => reportsAvailables[Number(year)]);

  const thisYearReportURL = reportsAvailables[lastYearAvailable];
  const pastYearsReportURL = pastReports;

  const reportUrl = thisYearReportURL['download_urls'][lng] || '#';

  return (
    <Wrapper>
      <div className='header'>
        <h3 className='header__title'>{ t('pdfDownload.header.title') }</h3>
        <p className='header__description'>{ t('pdfDownload.header.description') }</p>
      </div>
      <div className='reports'>
        <div className='reports__last'>
          <a href={ reportUrl } target='_blank'>
            <span>{ t('pdfDownload.reports.report', { year: thisYearReportURL?.year + 1 }) }</span>
            <span className='reports__caret' />
          </a>
        </div>
        <div className='previous-reports'>
          <div className='previous-reports__description'>
            { t('pdfDownload.reports.description') }
          </div>
          <div className='previous-reports__separator' />
          <div className='previous-reports__list'>
            <ul>
              { pastYearsReportURL && pastYearsReportURL.map(r => {
                  return <PreviousReport key={ r.year } report={ r } />
              }) }
            </ul>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default PdfDownload;
